module.exports = __webpack_public_path__ + "img/icon_lupa.c7c47d4f.svg";